import { render } from "./VerificationCode.vue?vue&type=template&id=43c2971d&scoped=true"
import script from "./VerificationCode.vue?vue&type=script&lang=js"
export * from "./VerificationCode.vue?vue&type=script&lang=js"

import "./VerificationCode.vue?vue&type=style&index=0&id=43c2971d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43c2971d"]])

export default __exports__